import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import { Link, useParams } from "react-router-dom";
import { IoSearch } from "react-icons/io5";
import axios from "axios";
import { IoIosClose } from "react-icons/io";
import { toast } from "react-toastify";
import { IoIosArrowDropdown } from "react-icons/io";
import { TbTableOptions } from "react-icons/tb";
import Papa from "papaparse";
import { RiDownloadCloudFill } from "react-icons/ri";
import Cookies from "js-cookie";
import { FaMedium } from "react-icons/fa";
import Menu_Items from "../Menu_Items";

function Manual_File_Upload() {
  const { id, int_id } = useParams();
  const [su_admin, setsu_admin] = useState(false)
  const [admin, setadmin] = useState(false)
  const [import_header, setimport_header] = useState([]);
  const [selected_header, setselected_header] = useState([]);
  const [alltables, setalltables] = useState([]);
  const [table_fields, settable_fields] = useState([]);
  const [value_none, setvalue_none] = useState([]);
  const [values, setvalues] = useState([]);
  const [search_file_headers, setsearch_file_headers] = useState("");
  const [search_header_mapping, setsearch_header_mapping] = useState("");
  const [header_mapping, setheader_mapping] = useState([]);
  const [values_mapping, setvalues_mapping] = useState([]);
  const [condition_deatils, setcondition_deatils] = useState([]);
  const [table_model, settable_model] = useState(false);

  const menus = [
    {
      name: 'Integrations',
      id
    },
    {
      name: 'In Bound',
      id,
      submenu: [
        { name: 'Schedule', id, int_id, type: 'In' },
        { name: 'API', id, int_id },
        { name: 'Manual', id, int_id }
      ]
    },
    (su_admin || admin ? { name: 'Users', id } : { name: null, id })
  ];
  const get_In_Bound_files = async () => {
    await axios.get(`/in_bound/tables/${int_id}`).then((res) => {
      setalltables(res.data);
    }).catch((err) => {
      console.log("error");
    });
  };
  const hadle_file = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const json_reader = new FileReader();
    const csv_reader = new FileReader();

    const processFileData = (data, format) => {
      const convertValue = (value, key) => {
        if (value === null || value === '' || value === 'null' || value === 'undefined') {
          return null;
        }
        if (!isNaN(value) && value.trim() !== '') {
          return parseFloat(value);
        }
        if (value.toLowerCase() === 'true') {
          return true;
        } else if (value.toLowerCase() === 'false') {
          return false;
        }
        const formatDate = (dateStr) => {
          const date = new Date(dateStr);
          if (!isNaN(date.getTime())) {
            let year = date.getFullYear();
            let month = (date.getMonth() + 1).toString().padStart(2, '0');
            let day = date.getDate().toString().padStart(2, '0');
            let hours = date.getHours().toString().padStart(2, '0');
            let minutes = date.getMinutes().toString().padStart(2, '0');
            let seconds = date.getSeconds().toString().padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
          }
          return null;
        };

        if (key === 'createdAt' || key === 'updatedAt') {
          return formatDate(value);
        }

        return value;
      };
      const processData = format === 'csv' ? data.map(row => {
        const convertedRow = {};
        for (const key in row) {
          if (row.hasOwnProperty(key)) {
            convertedRow[key] = convertValue(row[key], key);
          }
        }
        return convertedRow;
      }) : JSON.parse(data);
      const keynames = processData.flatMap(Object.keys);
      setimport_header([...new Set(keynames)]);
      setvalues(processData);
      setselected_header([]);
      setvalues_mapping([]);
      setheader_mapping([]);
    };
    csv_reader.onload = (event) => {
      const csvData = event.target.result;
      // Parse CSV data
      Papa.parse(csvData, {
        header: true, // Adjust based on whether your CSV has headers
        skipEmptyLines: true,
        complete: (result) => {
          processFileData(result.data, 'csv');
        },
      });
    };
    json_reader.onload = (e) => {
      const content = e.target.result;
      processFileData(content, 'json');
    };
    if (file.type === "application/json") {
      json_reader.readAsText(file);
    } else if (file.type === "text/csv") {
      csv_reader.readAsText(file);
    }
  };
  const handle_header = (header) => {
    const exist = selected_header.includes(header);
    if (exist) {
      setselected_header((prev) => prev.filter((h) => h !== header));
    } else {
      setselected_header([...selected_header, header]);
    }
    setheader_mapping((prevdata) =>
      prevdata.filter((obj) => (obj[header] ? !obj[header] : obj))
    );
    setvalues_mapping((prevdata) =>
      prevdata.filter((obj) => (obj[header] ? !obj[header] : obj))
    );
  };
  const handleDragStart = (event, index) => {
    event.dataTransfer.setData("text/plain", index); // Store the index of the dragged item
  };
  const handleDrop = (event, dropIndex) => {
    const dragIndex = event.dataTransfer.getData("text/plain"); // Get the index of the dragged item
    const updatedHeaders = [...selected_header];

    // Move the dragged item to the new position
    const [movedItem] = updatedHeaders.splice(dragIndex, 1);
    updatedHeaders.splice(dropIndex, 0, movedItem);

    // Update the state
    setselected_header(updatedHeaders);
  };
  const handleDragOver = (event) => {
    event.preventDefault(); // Prevent default to allow drop
  };
  const handle_header_mapping = (file_header, e) => {
    const value = e.target.value;
    const [tname, header] = value.split(" --- ");
    // const exist = table_fields.some(item => table in item);
    // setheader_mapping
    const exist = header_mapping.some((item) => file_header in item);

    if (!exist) {
      setheader_mapping((prevdata) => [
        ...prevdata,
        { [file_header]: { table: tname, header: header } },
      ]);
    } else {
      setheader_mapping((prevdata) =>
        prevdata.map((obj) => {
          return obj[file_header]
            ? { [file_header]: { table: tname, header: header } }
            : obj;
        })
      );
    }
  };
  const v_none = (vfield) => {
    const exist = value_none.includes(vfield);
    if (!exist) {
      setvalue_none([vfield]);
    } else {
      setvalue_none((prevdata) => prevdata.filter((val) => val !== vfield));
    }
  };
  const handle_value_mapping_input = (field, e) => {
    const { id, value } = e.target;
    if (value !== "") {
      const field_exist = values_mapping.some((item) => field in item);

      if (field_exist) {
        setvalues_mapping((prevdata) =>
          prevdata.map((obj) => {
            if (field in obj) {
              return {
                ...obj,
                [field]: obj[field]
                  .map((item) => {
                    if (item.old === id) {
                      return { old: id, new: value }; // Update existing entry
                    } else {
                      return item; // Return unchanged entry
                    }
                  })
                  .concat(
                    obj[field].some((item) => item.old === id)
                      ? []
                      : [{ old: id, new: value }]
                  ), // Add new entry if it doesn't exist
              };
            }
            return obj;
          })
        );
      } else {
        // Add new field with old and new values
        setvalues_mapping([
          ...values_mapping,
          { [field]: [{ old: id, new: value }] },
        ]);
      }
    }
  };
  // File Headers
  const file_headers = import_header.filter((header) =>
    header.toLowerCase().startsWith(search_file_headers.toLowerCase())
  );
  // Selected Headers
  const Selected_headers = selected_header.filter((header) =>
    header.toLowerCase().startsWith(search_header_mapping.toLowerCase())
  );
  const handle_con_table = (tname, k_name, value) => {
    // console.log('tname',tname);
    // console.log('k_name',k_name);
    // console.log('value',value);

    const exist = condition_deatils.some((item) => tname in item);
    if (!exist) {
      setcondition_deatils((prevdata) => [
        ...prevdata,
        { [tname]: { [k_name]: value } },
      ]);
    } else {
      setcondition_deatils((prevdata) =>
        prevdata.map((obj) => {
          if (obj[tname]) {
            return {
              ...obj,
              [tname]: {
                ...obj[tname],
                [k_name]: value,
              },
            };
          }
          return obj;
        })
      );
    }
  };
  const handle_table = async (table) => {
    const exist = table_fields.some((item) => table in item); // Check if the table exists in the current state

    if (!exist) {
      try {
        // Make the axios call to post data
        await axios
          .get(`/in_bound/fields/${table}/${int_id}`)
          .then((res) => {
            let fields = res.data.map((obj) => {
              return obj.Field;
            });
            // Update the state after the axios call resolves
            settable_fields((prevdata) => [...prevdata, { [table]: fields }]);
          })
          .catch((err) => {
            console.log("error");
          });
      } catch (err) {
        toast.error("Error", {
          autoClose: 2000,
        });
      }
    } else {
      // If the item exists, filter it out and update the state
      settable_fields((prevdata) =>
        prevdata.filter((item) => !(table in item))
      );
    }
  };
  const field_mapping_submit = async () => {
    let manual_data = {
      file_data: values,
      condition_deatils: condition_deatils,
      values_mapping: values_mapping,
      header_mapping: header_mapping,
    };
    try {
      await axios.post(`/in_bound/manual/insert_data/${int_id}`, manual_data).then((res) => {
        setimport_header([]);
        setvalues([]);
        setselected_header([]);
        setvalues_mapping([]);
        setheader_mapping([]);
        setcondition_deatils([]);
        settable_fields([]);
      })
        .catch((err) => {
          toast.error("File Data Inserted Error");
        });
    }
    catch {
      toast.error("File Data Inserted Error");
    }
  };
  const selected_condition = (tname, key) => {
    let value = condition_deatils.filter((obj) => obj[tname]);
    if (value.length > 0) {
      return value[0][tname][key];
    }
  };
  // const retrive_field_mapping = (header) => {
  //     let field_map_values = header_mapping.filter((obj) => obj[header] ? obj[header] : '');
  //     if (field_map_values.length > 0) {
  //         return field_map_values[0][header];
  //     }
  //     else {
  //         return { table: "", header: '' }
  //     }

  // };
  const get_level = () => {
    const level = Cookies.get("level");
    if (level === "Super Admin") {
      setsu_admin(true);
    }
    else if (level === 'Admin') {
      setadmin(true)
    }
  };
  useEffect(() => {
    get_In_Bound_files();
    get_level();
  }, []);

  return (
    <div className="container df fdc ac">
      <Navbar />
      <div className='main_box df'>
        <Menu_Items menu={menus} />
        <div className='content df fdc ac'>
          <div className='page_header df jb ac'>
            <div className='w90 df ac'>
              <FaMedium className='page_icon db' />
              <p>Manual In Bound</p>
            </div>
            <div className="w10 df">
              <label htmlFor='m_file' className='w30'><RiDownloadCloudFill className='icon3' /></label>
              <input type='file' accept='.csv,.json' id='m_file' style={{ display: "none" }} onChange={(e) => { hadle_file(e) }}></input>
              <Link to={`#`} className='w30' ><TbTableOptions className='icon3 g' onClick={() => { settable_model(true) }} /></Link>
            </div>

          </div>
          <div className='box df jc ac'>
            <div className="t_box1">
              <div className="box1_h df jc ac">
                <p className="df jc ac">Import Headers</p>
              </div>
              <div className="box_search df jc ac b0100" key={"1"}>
                <div className="searchicon df jc ac">
                  <IoSearch className="ser" />
                </div>
                <input
                  type="search"
                  id="ser_table"
                  placeholder="Search"
                  value={search_file_headers}
                  onChange={(e) => setsearch_file_headers(e.target.value)}
                />
              </div>
              <div className="h73 w100 df fdc ac b0100">
                {file_headers.length > 0 ? (
                  file_headers.map((header, index) => {
                    let Header = header.charAt(0).toUpperCase() + header.slice(1);
                    return (
                      <div key={`header${index}`} className="df gap h3 w80 ac cp">
                        <input
                          type="checkbox"
                          id={`${header}`}
                          onChange={() => {
                            handle_header(header);
                          }}
                          checked={selected_header.includes(header)}
                        />
                        <label htmlFor={`${header}`}>{Header}</label>
                      </div>
                    );
                  })
                ) : (
                  <p className="no_Records h50 w100 df jc ac ">No results found</p>
                )}
              </div>
            </div>
            <div className="t_box2">
              <div className="box1_h df jc ac">
                <p className="df jc ac">Selected Headers</p>
              </div>
              <div className="box_search df jc ac b0100">
                <div className="searchicon df jc ac">
                  <IoSearch className="ser" />
                </div>
                <input
                  type="search"
                  id="ser_table"
                  placeholder="Search"
                  value={search_header_mapping}
                  onChange={(e) => setsearch_header_mapping(e.target.value)}
                />
              </div>
              <div className="h73 w100 df fdc ac b0100">
                {Selected_headers.length > 0 &&
                  Selected_headers.map((sheader, index) => {
                    let SHeader =
                      sheader.charAt(0).toUpperCase() + sheader.slice(1);
                    return (
                      <div
                        key={`sh${sheader}`}
                        className="df gap h3 w80 ac jb cp"
                        draggable
                        onDragStart={(event) => handleDragStart(event, index)}
                        onDragOver={handleDragOver}
                        onDrop={(event) => handleDrop(event, index)}
                      >
                        <label htmlFor={`${sheader}`}>{SHeader}</label>
                        <IoIosClose
                          className="r"
                          onClick={() => handle_header(sheader)}
                        />
                      </div>
                    );
                  })}
                {
                  Selected_headers.length === 0 && <p className="no_Records h50 w100 df jc ac ">No results found</p>
                }
              </div>
            </div>
            <div className="t_box3">
              <div className="box1_h df jc ac">
                <p className="df jc ac">Values Mapping</p>
              </div>
              <div className="box_search df jc ac b0100">
                <div className="searchicon df jc ac">
                  <IoSearch className="ser" />
                </div>
                <input type="search" id="ser_table" placeholder="Search" />
              </div>
              <div className="h73 w100 df fdc ac b0100 of_a">
                {selected_header.length > 0 &&
                  selected_header.map((sheader, index) => {
                    let SHeader =
                      sheader.charAt(0).toUpperCase() + sheader.slice(1);
                    return (
                      <div
                        key={`value_mapping_${index}`}
                        className="w80 cp"
                        draggable
                        onDragStart={(event) => handleDragStart(event, index)}
                        onDragOver={handleDragOver}
                        onDrop={(event) => handleDrop(event, index)}
                      >
                        <div className="df jb ac h3">
                          <label htmlFor={`${sheader}`} className="p">
                            {SHeader}
                          </label>
                          <IoIosArrowDropdown
                            className="db"
                            onClick={() => v_none(sheader)}
                          />
                        </div>
                        <div
                          className={
                            value_none.includes(sheader)
                              ? `show w100 df fdc jc of_a gap`
                              : `hide`
                          }
                        >
                          {values.length > 0 && (
                            [
                              ...new Map(
                                values.map((obj) => [obj[sheader], obj])
                              ).values(),
                            ]
                              .sort((a, b) => (a[sheader] > b[sheader] ? 1 : -1)) // Sort in ascending order
                              .map((obj, index) => {
                                if (obj[sheader]) {
                                  return (
                                    <div
                                      className="h7 w100 df fdc jb"
                                      key={`v_m_${index}`}
                                    >
                                      <label htmlFor={obj[sheader]} className="h2">
                                        {obj[sheader]}
                                      </label>
                                      <input
                                        type="search"
                                        id={obj[sheader]}
                                        className="b1 h4"
                                        onChange={(e) => {
                                          handle_value_mapping_input(sheader, e);
                                        }}
                                      />
                                    </div>
                                  );
                                }
                              })
                          )}
                        </div>
                      </div>
                    );
                  })}
                {
                  selected_header.length === 0 && <p className="no_Records h50 w100 df jc ac ">No results found</p>
                }
              </div>
            </div>
            <div className="t_box4">
              <div className="box1_h df jc ac">
                <p className="df jc ac">Headers Mapping</p>
              </div>
              <div className="box_search df jc ac">
                <div className="searchicon df jc ac">
                  <IoSearch className="ser" />
                </div>
                <input
                  type="search"
                  id="ser_table"
                  placeholder="Search"
                  value={search_header_mapping}
                  onChange={(e) => setsearch_header_mapping(e.target.value)}
                />
              </div>
              <div className="h65 w100 df fdc ac of_a white">
                {Selected_headers.length > 0 &&
                  Selected_headers.map((sheader, index) => {
                    let SHeader =
                      sheader.charAt(0).toUpperCase() + sheader.slice(1);
                    return (
                      <div
                        key={`header_mapping_${index}`}
                        className="df gap h5 w90 ac jb cp"
                        draggable
                        onDragStart={(event) => handleDragStart(event, index)}
                        onDragOver={handleDragOver}
                        onDrop={(event) => handleDrop(event, index)}
                      >
                        <label className="w25" htmlFor={`${sheader}`}>
                          {SHeader}
                        </label>
                        <select
                          className="w50 h4"
                          key={`h_m${index}`}
                          onChange={(e) => {
                            handle_header_mapping(sheader, e);
                          }}
                        >
                          <option>Select Header</option>
                          {table_fields.length > 0 &&
                            table_fields.map((obj) => {
                              return Object.values(obj)[0].map((fnam) => {
                                let tableName =
                                  Object.keys(obj)[0].charAt(0).toUpperCase() +
                                  Object.keys(obj)[0].slice(1);
                                let Fname =
                                  fnam.charAt(0).toUpperCase() + fnam.slice(1);
                                return (
                                  <option value={`${Object.keys(obj)[0]} --- ${fnam}`}>
                                    {Fname} - {tableName}
                                  </option>
                                );
                              });
                            })}
                        </select>
                      </div>
                    );
                  })}
                {
                  Selected_headers.length === 0 && <p className="no_Records h50 w100 df jc ac ">No results found</p>
                }
              </div>
              {header_mapping.length > 0 && (
                <div className="h8 w100 df jc ac">
                  <button className="btn green" onClick={field_mapping_submit}>
                    Submit
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <div className="h_btn df jc ae">
        <p className="df jc ac">Manual File Upload</p>
        <div className="menu_bar h5 w25 df je ac gap1">
          <Link to={home_path} className="menu_icon df jc ac">
            <AiFillHome className="icon2" />
          </Link>
          {admin_level && (
            <Link to={`/integ/${id}`} className="menu_icon df jc ac">
              <SiGitconnected className="icon2" />
            </Link>
          )}
          {(admin_level || user_level) && (
            <>
              <Link to={`/in_bound_details/${id}/${int_id}`} className="menu_icon df jc ac">
                <RiImportFill className="icon2" />
              </Link>
              <label htmlFor="m_file" className="menu_icon df jc ac">
                <RiDownloadCloudFill className="icon2" />
              </label>
              <input
                type="file"
                accept=".csv,.json"
                id="m_file"
                style={{ display: "none" }}
                onChange={(e) => {
                  hadle_file(e);
                }}
              ></input>
              <div className="menu_icon df jc ac">
                <TbTableOptions
                  className="icon2"
                  onClick={() => {
                    settable_model(true);
                  }}
                />
              </div>
            </>
          )}
          <Link to={"/"} className="menu_icon df jc ac">
            <MdLogout className="icon2" />
          </Link>
        </div>
      </div> */}
      {/* <div className="t_box df jc ac">
        
      </div> */}
      {/* <Back location={`/in_bound_details/${id}/${int_id}`} /> */}
      {
        table_model && (
          <div className="model df jc ac">
            <div className="h70 w80 white br1 df jb ac">
              <div className="h70 w20 df fdc ac ">
                <div className="h5 w100 df jc ac h_blue br_f_1 fs08 w">
                  <p>Select Tables</p>
                </div>
                <div className="box_search df jc ac b0100" key={"1"}>
                  <div className="searchicon df jc ac">
                    <IoSearch className="ser" />
                  </div>
                  <input type="search" id="ser_table" placeholder="Search" />
                </div>
                <div className="h60 w100 of_a b0100">
                  {
                    //
                    alltables &&
                    alltables.map((tnam) => {
                      let tableName =
                        tnam.charAt(0).toUpperCase() + tnam.slice(1);
                      return (
                        <div className="h3 pad0101 w100 df ac gap" key={tnam}>
                          <input
                            type="checkbox"
                            id={tnam}
                            onChange={() => {
                              handle_table(tnam);
                            }}
                            checked={table_fields.some((item) => tnam in item)}
                          />
                          <label htmlFor={tnam}>{tableName}</label>
                        </div>
                      );
                    })
                  }
                </div>
              </div>
              <div className="h70 w80 df fdc ac">
                <div className="h5 w100 p df jc ac h_blue w br_l_1">
                  <p>Set Conditions</p>
                </div>
                <div className="box_search df jc ac b0100" key={"1"}>
                  {/* <div className='searchicon df jc ac'><IoSearch className='ser' /></div>
                                <input type='search' id='ser_table' placeholder='Search' /> */}
                </div>
                <div className="h50 w100 of_a df fdc gap ac">
                  {table_fields.map((obj, index) => {
                    let tablename =
                      Object.keys(obj)[0].charAt(0).toUpperCase() +
                      Object.keys(obj)[0].slice(1);
                    return (
                      <div className="h5 w100 df js ac" key={index}>
                        <div className="df fdc jb h3 w25">
                          <label>Primary Table</label>
                          <select defaultValue={tablename}>
                            <option>{tablename}</option>
                          </select>
                        </div>
                        <div className="df fdc jb h3 w25">
                          <label>Primary Field</label>
                          <select
                            value={
                              selected_condition(Object.keys(obj)[0], "field") ||
                              ""
                            }
                            onChange={(e) =>
                              handle_con_table(
                                Object.keys(obj)[0],
                                "field",
                                e.target.value
                              )
                            }
                          >
                            <option value="" disabled>
                              Select Field
                            </option>
                            {obj[Object.keys(obj)[0]].map((field, idx) => {
                              let Field =
                                field.charAt(0).toUpperCase() + field.slice(1);
                              return (
                                <option key={idx} value={field}>
                                  {Field}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        <div className="df fdc jb h3 w25">
                          <label>Primary File Header</label>
                          <select
                            value={
                              selected_condition(Object.keys(obj)[0], "header") ||
                              ""
                            }
                            onChange={(e) =>
                              handle_con_table(
                                Object.keys(obj)[0],
                                "header",
                                e.target.value
                              )
                            }
                          >
                            <option value="" disabled>
                              Select Header
                            </option>
                            {file_headers.map((header, idx) => {
                              let Header =
                                header.charAt(0).toUpperCase() + header.slice(1);
                              return (
                                <option key={idx} value={header}>
                                  {Header}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="h10 w80 df jc ac gap2">
                  <button
                    className="btn l_black"
                    onClick={() => {
                      settable_model(false);
                    }}
                  >
                    close
                  </button>
                  <button
                    className="btn green"
                    onClick={() => {
                      settable_model(false);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }
    </div >
  );
}

export default Manual_File_Upload;
